import { Share as ShareIcon } from "@mui/icons-material";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";
import { Button } from "@/components/core";

export function ShareButton({ onClick }: any) {
  const { t } = useTranslation("common");

  return (
    <Button variant="contained" startIcon={<ShareIcon />} onClick={onClick}>
      {t("share")}
    </Button>
  );
}

ShareButton.propTypes = {
  onClick: PropTypes.func,
};
